import React, { Component } from 'react';
import { Translate } from '$common';



export default class YesNo extends Component {
  static type = 'yes_no';
  static elementName = Translate.get('yes_no');
  static icon = 'check';

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/task-form/question-types/yes-no.js